module.exports = __webpack_public_path__ + "img/p19.1a92d462.png";